(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:ShowHistoryCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('ShowHistoryCtrl', ShowHistoryCtrl);

    function ShowHistoryCtrl($uibModalInstance,modalParams) {
        var vm = this;
        vm.model={
            history : modalParams.history || []
        }

        vm.closeMe = function(){
            $uibModalInstance.close();
        };
    }
}());
